import React from 'react';
import classNames from 'classnames';
import {
  Card,
  Typography,
} from '@one-thd/sui-atomic-components';
import { OrderTracking } from '@one-thd/sui-icons';

interface ActiveOrdersNullStateProps {
  componentLocation?: string;
}

export const ActiveOrdersNullState = ({ componentLocation = 'default' }: ActiveOrdersNullStateProps) => {
  return (
    <div
      data-component="ActiveOrdersNullState"
      data-testid="active-orders-null-state"
      data-component-location={componentLocation || 'default'}
      className="sui-h-full"
    >
      <Card
        className="sui-border-1 sui-border-primary sui-rounded-base sui-h-full"
        disablePadding
        CardContentProps={{
          className: classNames(
            'sui-flex',
            'sui-flex-col',
            'sui-gap-4',
            'sui-h-full',
            'sui-p-4',
            'sui-w-full'
          ),
        }}
      >
        <div className="sui-flex sui-items-start sui-justify-between sui-gap-4 sui-w-full">
          <div className="sui-flex sui-items-center sui-gap-3 sui-min-w-0">
            <span className="sui-flex sui-shrink-0 sui-text-primary">
              <OrderTracking />
            </span>
            <div className="sui-flex sui-flex-wrap sui-items-center sui-gap-x-2 sui-gap-y-1">
              <Typography
                variant="h4"
                weight="display"
                className="sui-leading-none"
              >
                Active Deliveries & Pickups
              </Typography>
            </div>
          </div>
        </div>

        <div className="sui-h-full sui-flex sui-items-center sui-justify-center sui-text-center">
          <Typography variant="body-base">No active deliveries or pickups at this time.</Typography>
        </div>
      </Card>
    </div>
  );
};

ActiveOrdersNullState.defaultProps = {
  componentLocation: 'default',
};
